import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Modal, CardContent, TextField, Chip } from '@mui/material';
import MainCard from 'components/MainCard';
import '@photo-sphere-viewer/core/index.css';
import { getCoordsByAddress } from 'components/axios/geocode';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import { Controller } from 'react-hook-form';

export function KaKaoAddressSearchLayer({register, setValue, errors, setAddressInfo, objName, defaultVal = ''}) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
                // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
      setOpen(true);
      // console.log(defaultVal)
      if (!defaultVal)
        setSelectAddress('')
    }
    const handleClose = () => {
      setOpen(false);
      init()
    }

    useEffect(()=>{
      // console.log(defaultVal)
      setSelectAddress(defaultVal)
    }, [defaultVal])

    const [addressText, setAddressText] = useState("");
    const [addresss, setAddresss] = useState([]);
    const [address, setAddress] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [selectAddress, setSelectAddress] = useState(defaultVal);
    const [remainAddress, setRemainAddress] = useState('');

    const handleSearch = async () => {
      if (!addressText) {
        handleAlertClick(t('message.common.error.text.address.input'));
        return;
      }
      try {
        const results = await getCoordsByAddress(addressText, t);
        if (results.meta.total_count === 0) {
          handleAlertClick(t('message.common.error.text.correct.address.input'));
          return;
        }

        setTotalCount(results.meta.total_count);
        setAddresss(results.documents.map((d) => ({
            address_name: d.address_name,
            lat: parseFloat(d.y),
            lng: parseFloat(d.x),
        })))
      } catch(e) {
        alert(e)
      }
    };

    const handleSelect = (candidate) => {
      setAddress(candidate)
    };

    const handleWrite = () => {
      const addressStr = address.address_name + ' ' + remainAddress;
      setAddressInfo?.({...address, address_name: addressStr})
      setSelectAddress(addressStr)
      
      setValue(objName, addressStr, {
        shouldValidate: true,
        shouldDirty: true,
      });
      // console.log(addressStr)
      // init()
      handleClose();
    }

    const init = () => {
      // console.log(selectAddress)
      setAddressText('')
      setAddress({})
      setTotalCount(0)
      setAddresss([])
    }
    
    return (
      <>
        <TextField id={objName} 
            {...register(objName, {
                // required : t('message.common.error.text.address.input')
            })} 
            value={selectAddress}
            key={objName}
            InputProps={{ readOnly: true }}
            sx={{ m: 1, minWidth: '70%', width: '70%' }}
            onClick={handleOpen}
        />
        {/* {errors?.[objName] && <small role="alert"><br></br>{errors[objName].message}</small>} */}
  
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard style={{maxWidth:"600px", width:"90%", height:"70vh"}} title="" modal darkTitle content={false}>
            <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
                <div>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.title.address.search')} color="success" />
                </div>

                <div>
                    <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                        {t('message.common.btn.close')}
                    </Button>
                </div>
            </div>
            <CardContent style={{height:"100%"}}>
              <div className='vr_pop_box'>
                <div style={{ padding: "1rem" }}>
                  <TextField id={objName} 
                    onChange={(e) => setAddressText(e.target.value)}
                    placeholder={t('message.common.text.enter.road.name.address')}
                    style={{ width: "400px", marginRight: "8px" }}
                  />
                  <Button variant="contained" color="info" size="small" onClick={handleSearch}>{t('message.common.btn.search')}</Button>

                  {addresss.length > 0 && (
                    <>
                    <div style={{ width: "520px", maxHeight: "360px", marginTop: "10px", border: "1px solid #ccc", padding: "10px", overflowY: "auto", overflowX: "hidden" }}>
                      <h4>{t('message.common.alert.use.address.select')} : {totalCount} 개</h4>
                      <ul>
                        {addresss.map((c, i) => (
                          <li
                            key={i}
                            onClick={() => handleSelect(c)}
                            style={{
                              cursor: "pointer",
                              padding: "4px 0",
                              borderBottom: "1px dashed #ddd",
                              backgroundColor: address.address_name === c.address_name ? "#a1a6aa" : "transparent"
                            }}
                          >
                            {c.address_name}
                          </li>
                        ))}
                      </ul>
                    </div>
                    {address?.address_name &&
                      <div style={{paddingTop:'10px'}}>
                        <TextField id={'remainAddress'} 
                          onChange={(e) => setRemainAddress(e.target.value)}
                          placeholder={t('message.common.text.enter.remain.address')}
                          style={{ width: "400px", marginRight: "8px" }}
                        />
                        <Button variant="contained" color="info" size="small" onClick={handleWrite}>{t('message.common.btn.write')}</Button>
                      </div>
                    }
                    </>
                  )}
                </div>
              </div>
            </CardContent>
  
          </MainCard>
        </Modal>
      </>
    )
  }
  
  export default KaKaoAddressSearchLayer;
  